export default __webpack_public_path__ + "static/media/Strawberry-Chocolate-Cake.83dc086e.jpg";